"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M17.36 10.944l-1.063-2.64a1.08 1.08 0 00-.6-.6l-2.64-1.064a.542.542 0 00-.587.12l-5.71 5.71a.543.543 0 000 .769l4.001 4.001a.543.543 0 00.77 0l5.71-5.71a.54.54 0 00.12-.585zm-2.578-.597a.798.798 0 11-1.129-1.129.798.798 0 011.13 1.13z" }), "Store");
//# sourceMappingURL=Store.js.map